import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createFirmEntry = createAsyncThunk('createFirmEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertFirm`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateFirmEntry = createAsyncThunk('updateFirmEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateFirm`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchCompanyData = createAsyncThunk('fetchCompanyData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getFirmlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleFirm = createAsyncThunk('fetchSingleFirm', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getFirmlist&firmId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleFirm = createAsyncThunk('deleteSingleFirm', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteFirm&firmId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const companySlice = createSlice({
    name: 'FirmData',
    initialState: {
        isLoading: false,
        firm: null,
        deleteFirm: null,
        singleFirm: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCompanyData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCompanyData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.firm = action.payload;
        });
        builder.addCase(fetchCompanyData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleFirm.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleFirm.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteFirm = action.payload;
        });
        builder.addCase(deleteSingleFirm.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleFirm.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleFirm.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleFirm = action.payload;
        });
        builder.addCase(fetchSingleFirm.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default companySlice.reducer;
